import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CustomPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    cardViewData: {
      paddingBottom: 12,
      display: 'flex',
      flexDirection: 'row',
    },
    cardViewDataGrid: {
      display: 'flex',
      flexDirection: 'row',
    },
    cardViewDataName: {
      color: 'rgba(255, 255, 255, 0.6)',
      fontSize: 16,
      letterSpacing: '0.5px',
      fontWeight: 400,
      fontStyle: 'normal',
    },
    cardViewDataValue: {
      color: 'rgba(255, 255, 255, 0.87)',
      fontWeight: 'normal',
      fontSize: 16,
      letterSpacing: '0.5px',
    },
    cardViewGrid: {
      margin: 16,
      '& .tooltipTextColor': {
        color: 'rgba(255, 255, 255, 0.87) ',
      },
      '& .inlineGrid': {
        display: 'inline ',
      },
    },
    outerCard: {
      padding: '16px',
      marginBottom: 0,
      borderRadius: '8px 8px 0px 0px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      cursor: 'pointer',
    },
    greenDot: {
      height: '5px',
      width: '5px',
      borderRadius: '50%',
      display: 'inline-block',
      backgroundColor: '#2AAB3F',
      margin: '0px 8px 4px 8px',
    },
    areaPcsId: {
      fontWeight: 'normal',
      color: 'rgba(255, 255, 255, .38)',
    },
    inlineBlock: {
      display: 'inline-block',
    },
    messageIcon: {
      verticalAlign: 'text-bottom',
      marginLeft: 16,
    },
    auditLogGrid: {
      display: 'inline-flex',
      cursor: 'pointer',
    },
    auditLogs: {
      letterSpacing: '1.25px',
      paddingRight: '10px',
    },
    customHistory: {
      width: '24px',
      height: '24px',
      marginRight: '10px',
      cursor: 'pointer',
    },
    dividerGrid: {
      marginLeft: 16,
      marginRight: 16,
      alignSelf: 'center',
      height: 32,
      background: 'rgba(255,255,255,0.4)',
    },
    deleteIcon: {
      marginLeft: 16,
    },
    cardViewBelowGrid: {
      padding: '16px',
      marginTop: 0,
      marginBottom: 16,
      borderRadius: '0px 0px 8px 8px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    cardViewInfo: {
      display: 'flex',
      flexDirection: 'column',
    },
    cardViewInfoGrid: {
      paddingBottom: 0,
    },
    cardViewDescription: {
      letterSpacing: '0.5px',
      maxHeight: '72px',
      overflow: 'hidden',
    },
    alertCircle: {
      width: '24px',
      height: '24px',
      marginLeft: '10px',
      marginBottom: '-5px',
      cursor: 'pointer',
    },
    deficiencyDetailsCard: {
      display: 'inline',
    },
    cardHeightGreater: {
      paddingRight: 10,
    },
    cardHeightLess: {
      paddingRight: 75,
    },
    photoCardAdd: {
      width: '100px',
      height: '100px',
      border: `1px dashed ${CustomPalette.elevation.dp8}`,
      borderRadius: '4px',
      backgroundColor: CustomPalette.elevation.dp1,
      cursor: 'pointer',
    },
    cardViewPhotoBackground: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },
    photoDiv: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100px',
      '& .photoCardAddText': {
        marginTop: '10px',
        textAlign: 'center',
      },
    },
    cardViewPhotoBackgroundFont: {
      textAlign: 'center',
      fontWeight: 400,
      color: 'rgba(255, 255, 255, 0.87)',
      fontSize: 16,
      alignSelf: 'center',
    },
    loaderCardView: {
      margin: '25px 0px 0px 30px',
    },
    reInspected: {
      backgroundColor: '#2AAB3F',
      marginTop: '25px',
      marginLeft: '16px',
    },
    removedFromPlanning: {
      backgroundColor: '#dd7676',
      marginTop: '25px',
      marginLeft: '16px',
    },
    activeDeficiencyView: {
      display: 'grid',
      justifyItems: 'end',
      marginRight: '-35px',
    },
  }),
);

export default useStyles;
